import * as React from "react"
import { BadgeSkeleton } from "../../common/skeletons"
import { Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import parse from "html-react-parser"
import { useLocalUserType } from "../../../hooks/useLocalUserType"

interface FadeBadgesProps {
  isSmallView?: boolean
  infoText?: string
  customStyles?: React.CSSProperties
}

export const FadeBadges: React.FC<FadeBadgesProps> = ({
  isSmallView,
  infoText,
  customStyles
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isModerator, isBroadcaster } = useLocalUserType()
  return (
    <>
      {(isModerator || isBroadcaster) && !isSmallView && (
        <Flex
          padding="0.5rem"
          border="2px solid"
          borderRadius="0.5rem"
          width={isSmallView && "100%"}
          lineHeight={1.2}
          fontSize={"sm"}
          color={roomStyles.servicePanelElementPrimaryText ?? "#495057"}
          borderColor={roomStyles?.servicePanelElementBorder ?? "#E2E8F0"}
          background={roomStyles?.servicePanelElementBackground ?? "white"}
          className={"fade-badges-container"}
          style={{ ...customStyles }}
        >
          {parse(infoText)}
        </Flex>
      )}
      <BadgeSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{
          opacity: "35%",
          marginTop: isSmallView && "10px",
          ...customStyles
        }}
      />
      <BadgeSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{
          opacity: "25%",
          marginTop: isSmallView && "10px",
          ...customStyles
        }}
      />
      <BadgeSkeleton
        isSmallView={isSmallView}
        offFade={true}
        containerProps={{
          opacity: "15%",
          marginTop: isSmallView && "10px",
          ...customStyles
        }}
      />
    </>
  )
}
